import GeneralInitialState from './GeneralInitialState';

export const generalReducer = (state = GeneralInitialState, action) => {
    switch (action.type) {
        case 'ADD_MESSAGE':
            return {
                ...state,
                message: action.payload
                    ? { text: action.payload.text, status: action.payload.status }
                    : null
            };
        case 'LOAD_GENERICS':
            return {
                ...state,
                generics: { ...state.generics, [action.listName]: action.payload }
            };
        case 'GET_PATIENT_FORM_STRUCTURE':
            return { ...state, formStructure: action.payload };
        case 'SOCKET_CONDITION': {
            if (action.data) {
                return {
                    ...state,
                    socketCondition: action.payload,
                    realTimeConnection: action.data
                };
            } else {
                return {
                    ...state,
                    socketCondition: action.payload,
                    realTimeConnection: {
                        firstRetryTime: null,
                        numberOfRetries: 0
                    }
                };
            }
        }
        default:
            return { ...state };
    }
};
